import "../styles/Body.css";

function Body(props) {
  return (
    <div className="d-body">
      {props.children}
    </div>
  );
}

export default Body;